import axiosInstance from "Api";
import { useApiFetcherSWR } from "hooks/SwrCustom";

//Home

const getSubstitutions = () => {
  return axiosInstance.get("substitutor/substitutions");
};
const getPlanboard = (weeks) => {
  return axiosInstance.get(`substitutor/planboard?weeks=${weeks}`);
};
const getFullPeriod = (id) => {
  return axiosInstance.get(`substitutor/full-period/${id}`);
}
const getCurrentRequest = (id) => {
  return axiosInstance.get(`substitutor/current-request/${id}`);
}

const getOpenRequest = (id) => {
  return axiosInstance.get(`substitutor/open-request/${id}`);
}

const getAllRequest = (id) => {
  return axiosInstance.get(`substitutor/all-request/${id}`);
}
const updateSubstitutionStatus = (id, payload) => {
  return axiosInstance.post(
    `substitutor/substitution/${id}/dayparts`,
    payload
  );
}

//Overview
const getOverviewData = (begin, eind, communityId) => {
  return axiosInstance.get(
    `vervanger/overview?begin=${begin}&eind=${eind}&iCommunityId=${communityId}`
  );
};


const UrenoverzichtService = {
  getSubstitutions,
  getPlanboard,
  getFullPeriod,
  getCurrentRequest,
  getOpenRequest,
  getAllRequest,
  updateSubstitutionStatus,
  getOverviewData

};
export default UrenoverzichtService;

//new implementation


export const API_ENDPOINT = {
  GET_DOCUMENTS: {
    url: "document-list",
    method: "get",
  },

  DELETE_DOCUMENT: {
    url: "document-delete",
    method: "delete",
  },

  UPDATE_REMINDER_DATE: {
    url: "update-herinneringsdatum",
    method: "post",
  },

  DOWNLOAD_DOCUMENT: {
    url: "document-download",
    method: "get",
  },
};

export const useDocuments = () =>
  useApiFetcherSWR(API_ENDPOINT.GET_DOCUMENTS);

export const useDeleteDocument = () =>
  useApiFetcherSWR(API_ENDPOINT.DELETE_DOCUMENT);

export const useUpdateReminderDate = () =>
  useApiFetcherSWR(API_ENDPOINT.UPDATE_REMINDER_DATE);

export const useDownloadDocument = (id) =>
  useApiFetcherSWR(
    id ? API_ENDPOINT.DOWNLOAD_DOCUMENT(id) : null
  );